var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoAuthorizedBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1666 10L17.1332 7.675L17.4166 4.6L14.4083 3.91667L12.8333 1.25L9.99992 2.46667L7.16658 1.25L5.59158 3.90833L2.58325 4.58333L2.86659 7.66667L0.833252 10L2.86659 12.325L2.58325 15.4083L5.59158 16.0917L7.16658 18.75L9.99992 17.525L12.8333 18.7417L14.4083 16.0833L17.4166 15.4L17.1332 12.325L19.1666 10ZM7.81658 13.3417L5.83325 11.3417C5.50825 11.0167 5.50825 10.4917 5.83325 10.1667L5.89158 10.1083C6.21658 9.78333 6.74992 9.78333 7.07492 10.1083L8.41658 11.4583L12.7083 7.15833C13.0333 6.83333 13.5666 6.83333 13.8916 7.15833L13.9499 7.21667C14.2749 7.54167 14.2749 8.06667 13.9499 8.39167L9.01658 13.3417C8.67492 13.6667 8.14992 13.6667 7.81658 13.3417Z",
    fill: "#7AACFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAuthorizedBadge);
export default __webpack_public_path__ + "static/media/ico-authorized-badge.4960e39bcb4707fef1423276dade5764.svg";
export { ForwardRef as ReactComponent };